/* eslint-disable no-console */

import * as Sentry from '@sentry/react';
import React, { Component } from 'react';

import { IS_PRODUCTION } from 'constants/Global';

import ErrorRefreshPage from './ErrorRefreshPage';

class ErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    if (!IS_PRODUCTION) {
      console.error(error);
    }

    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (!IS_PRODUCTION) {
      console.error(error, errorInfo);
    }

    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    return hasError ? <ErrorRefreshPage /> : children;
  }
}

export default ErrorHandler;
